<login-ui-container [showLoginBanner]="showDialog">
    <p class="login-text fw-5 mb-5 text-center login-text">
        {{SELECT_DATABASE_NEW}}
    </p>
    <change-database [callback]="connectToDatabase" [onCancel]="onCancel" [cancelText]="CANCEL"></change-database>
</login-ui-container>